<template>
  <div class="position-assigment mb-3">
    <validation-observer ref="profileVO" disabled>
      <div class="row mx-0">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <div v-if="readonly" class="ml-3">
              <label class="readonly-label">Puesto:</label>
              <span class="field-value">
                {{ model.eduespPositionName || '-' }}
              </span>
            </div>
            <div v-else>
              <validation-provider v-slot="{ errors }">
                <custom-drop-down
                  v-model="selectedPosition"
                  :options="positionOptions"
                  label="Puesto:"
                  fieldname="name"
                  fieldkey="id"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor de seleccionar un puesto."
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <validation-provider
              :rules="{
                required: isTeacher && (!model.staffId && !model.teachPositionNo),
              }"
              v-slot="{ errors }"
            >
              <custom-input
                v-model="model.teachPositionNo"
                label="Número de Puesto:"
                @change="handlerTeachPositionNo"
                v-mask="alphanumericMask"
                type="text"
                maxlength="10"
                :disabled="readonly"
                :error="errors[0]"
                custom-error-msg="El número de puesto es requerido."
              />
            </validation-provider>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <validation-provider
              :rules="{
                required: isTeacher && (!model.staffId && !model.teachPositionNo),
              }"
              v-slot="{ errors }"
            >
              <custom-input
                v-model="model.staffId"
                label="Número de Empleado:"
                v-mask="alphanumericMask"
                @change="handlerStaffIdByInput"
                type="text"
                maxlength="10"
                :disabled="readonly"
                :error="errors[0]"
                custom-error-msg="El Número de Empleado"
              />
            </validation-provider>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import eduespService from '@/services/eduesp';
import Roles from '@/utils/constants/rolesIds';
import { mask } from 'ke-the-mask';
import debounce from 'lodash/debounce';
const  ALPHA_NUMERIC = 'XXXXXXXXXX'
const TIME =1500;
export default {
  name: 'PositionAssignment',
  components: { CustomInput, CustomDropDown },
  directives: {
    mask,
  },
  props: {
    data:{
      type: Object,
      default: () => {},
    },
    profile: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    userProfile: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      eduespPositionCode: null,
      eduespPositionName: null,
      teachPositionNo: null,
      staffId: null,
    },
    teachPositionNoByinput: null,
    staffIdByInput: null,
    delayTimer:null,
    positionOptions: [],
  }),
  computed: {
    alphanumericMask() {
      return ALPHA_NUMERIC ; // Regular expression for allowing only letters and numbers.
    },
    selectedPosition: {
      get() {
        return {
          id: this.model.eduespPositionCode,
          name: this.model.eduespPositionName || '',
        }
      },
      set(value) {
        this.model = {
          ...this.model,
          eduespPositionCode: value?.id,
          eduespPositionName: value?.name,
        };
      },
    },
    isTeacher() {
      const teacherRoles = [
        Roles.MaestroVerano,
        Roles.Maestro,
        Roles.MaestroItinerante,
        Roles.MaestroTransitorio
      ];
      return this.userProfile?.roles.some(x => teacherRoles.includes(x.roleId.toUpperCase()));
    },
    isPrivateTeacher() {
      const teacherRoles = [
        Roles.MaestroPrivado,
      ];
      return this.userProfile?.roles.some(x => teacherRoles.includes(x.roleId.toUpperCase()));
    },
  },
  watch: {
    profile: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.model = {
            eduespPositionCode: newVal.eduespPositionCode,
            eduespPositionName: newVal.eduespPositionName,
            teachPositionNo: newVal.teachPositionNo,
            staffId: newVal.staffId,
          };
        }
      }
    },
    data: {
      immediate: true,
      deep: true,
      handler(newVal) {
       
        this.model.staffId=newVal.employee
        this.model.teachPositionNo=newVal.positionNumber
       
      },
    },
  },
  async created() {
    await this.getPositions();
  },
  methods: {
    async getPositions() {
      const { data } = await eduespService.getJobPositionsKeyValue();
      this.positionOptions = data;
    },
    handlerTeachPositionNo: debounce(function(ev) {
      this.teachPositionNoByinput = ev;
      if (this.teachPositionNoByinput.length >= 6) {
        let dataToSend = { positionNumber: this.teachPositionNoByinput, from: "position" };
        this.$emit('accountdata', dataToSend);
      }
    }, TIME),
    handlerStaffIdByInput: debounce(function(ev) {
      this.staffIdByInput = ev;
      if (this.staffIdByInput.length >= 5) {
        let dataToSend = { employeeNumber: this.staffIdByInput, from: "employee" };
        this.$emit('accountdata', dataToSend);
        this.model.staffId = this.staffIdByInput;
      }
    }, TIME),
    getModel() {
      return { ...this.model };
    },
  },
};
</script>
